import React, { useRef } from 'react';
import { RcDialerContext } from './utils';
var RcDialer = function (_a) {
    var children = _a.children;
    var dialPadActionRef = useRef(null);
    var onInsertRef = useRef(null);
    var inputRef = useRef(null);
    var onDeleteRef = useRef(null);
    var onClearRef = useRef(null);
    return (React.createElement(RcDialerContext.Provider, { value: {
            dialPadActionRef: dialPadActionRef,
            onInsertRef: onInsertRef,
            onDeleteRef: onDeleteRef,
            inputRef: inputRef,
            onClearRef: onClearRef,
        } },
        React.createElement(React.Fragment, null, children)));
};
RcDialer.defaultProps = {};
RcDialer.displayName = 'RcDialer';
export { RcDialer };
